var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { URLs } from "../url";
import { getHeader } from "../headers";
import { handleUnauthorized } from "../fetchRequest";
var safeParseJson = function (response) { return __awaiter(void 0, void 0, void 0, function () {
    var text, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, response.text()];
            case 1:
                text = _a.sent();
                if (!text)
                    return [2 /*return*/, null];
                return [2 /*return*/, JSON.parse(text)];
            case 2:
                e_1 = _a.sent();
                console.warn("quoteComments: no se pudo parsear el cuerpo JSON", e_1);
                return [2 /*return*/, null];
            case 3: return [2 /*return*/];
        }
    });
}); };
export var postQuoteCommentAPI = function (quoteId, body) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions, response, parsed;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = process.env.REACT_APP_HOST_API + URLs.quote + "/".concat(quoteId, "/comments");
                requestOptions = {
                    method: "POST",
                    body: JSON.stringify(body),
                    headers: getHeader(),
                };
                return [4 /*yield*/, fetch(newURL, requestOptions)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, safeParseJson(response)];
            case 2:
                parsed = _a.sent();
                if (!response.ok) {
                    handleUnauthorized(response.status);
                    throw __assign({ status: response.status }, (parsed && typeof parsed === "object" ? parsed : {}));
                }
                return [2 /*return*/, parsed];
        }
    });
}); };
export var putQuoteCommentAPI = function (quoteId, commentId, body) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions, response, parsed;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = process.env.REACT_APP_HOST_API +
                    URLs.quote +
                    "/".concat(quoteId, "/comments/").concat(commentId);
                requestOptions = {
                    method: "PUT",
                    body: JSON.stringify(body),
                    headers: getHeader(),
                };
                return [4 /*yield*/, fetch(newURL, requestOptions)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, safeParseJson(response)];
            case 2:
                parsed = _a.sent();
                if (!response.ok) {
                    handleUnauthorized(response.status);
                    throw __assign({ status: response.status }, (parsed && typeof parsed === "object" ? parsed : {}));
                }
                return [2 /*return*/, parsed];
        }
    });
}); };
export var deleteQuoteCommentAPI = function (quoteId, commentId) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions, response, parsed;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = process.env.REACT_APP_HOST_API +
                    URLs.quote +
                    "/".concat(quoteId, "/comments/").concat(commentId);
                requestOptions = {
                    method: "DELETE",
                    headers: getHeader(),
                };
                return [4 /*yield*/, fetch(newURL, requestOptions)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, safeParseJson(response)];
            case 2:
                parsed = _a.sent();
                if (!response.ok) {
                    handleUnauthorized(response.status);
                    throw __assign({ status: response.status }, (parsed && typeof parsed === "object" ? parsed : {}));
                }
                return [2 /*return*/, parsed];
        }
    });
}); };
export var getQuoteCommentsAPI = function (quoteId, params) {
    if (params === void 0) { params = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var _a, enable, _b, page, _c, limit, query, newURL, requestOptions, response, parsed;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _a = params.enable, enable = _a === void 0 ? true : _a, _b = params.page, page = _b === void 0 ? 1 : _b, _c = params.limit, limit = _c === void 0 ? 10 : _c;
                    query = new URLSearchParams({
                        enable: String(enable),
                        page: String(page),
                        limit: String(limit),
                    }).toString();
                    newURL = process.env.REACT_APP_HOST_API +
                        URLs.quote +
                        "/".concat(quoteId, "/comments?").concat(query);
                    requestOptions = {
                        method: "GET",
                        headers: getHeader(),
                    };
                    return [4 /*yield*/, fetch(newURL, requestOptions)];
                case 1:
                    response = _d.sent();
                    return [4 /*yield*/, safeParseJson(response)];
                case 2:
                    parsed = _d.sent();
                    if (!response.ok) {
                        handleUnauthorized(response.status);
                        throw __assign({ status: response.status }, (parsed && typeof parsed === "object" ? parsed : {}));
                    }
                    return [2 /*return*/, parsed];
            }
        });
    });
};
